export default function Input({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  autoComplete = "off",
  name = "",
  width,
  note,
  rows = 1,
  disabled = false,
  required = false,
  labelClassName = "text-sm font-medium",
  pattern,
  title,
}: {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  name?: string;
  width?: number;
  note?: string;
  rows?: number;
  disabled?: boolean;
  required?: boolean;
  labelClassName?: string;
  pattern?: string;
  title?: string;
}) {
  return (
    <div className="flex flex-col gap-2" style={{ width }}>
      {label && <div className={labelClassName}>{label}</div>}
      {rows > 1 ? (
        <textarea
          rows={rows}
          onChange={(e) => onChange && onChange(e.target.value)}
          className={`border rounded-md p-2 ${disabled ? "text-slate-400" : ""}`}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          name={name}
          disabled={disabled}
        />
      ) : (
        <input
          onChange={(e) => onChange && onChange(e.target.value)}
          className={`border rounded-md p-2 ${disabled ? "text-slate-400" : ""}`}
          value={value}
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          name={name}
          disabled={disabled}
          required={required}
          pattern={pattern}
          title={title}
        />
      )}
      {note && <div className="text-xs text-gray-500">{note}</div>}
    </div>
  );
}
